module.exports = __webpack_public_path__ + "img/yjt.8a72632a.png";